import { render } from "./SymbolPage.vue?vue&type=template&id=faa64f32"
import script from "./SymbolPage.vue?vue&type=script&lang=js"
export * from "./SymbolPage.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./SymbolPage.vue?vue&type=style&index=0&id=faa64f32&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script